/** Card colour palette (dark theme). Background mode fills the card; strip mode paints a 6px top bar. */
export const CARD_COLOR_CSS: Record<string, { bg: string; fg: string }> = {
  white: { bg: "#f3f3f4", fg: "#1b2536" },
  charcoal: { bg: "#262626", fg: "#ffffff" },
  grey: { bg: "#5f6672", fg: "#ffffff" },
  red: { bg: "#c0392b", fg: "#ffffff" },
  orange: { bg: "#e67e22", fg: "#111111" },
  yellow: { bg: "#f1c40f", fg: "#111111" },
  green: { bg: "#27ae60", fg: "#ffffff" },
  cyan: { bg: "#1abc9c", fg: "#111111" },
  blue: { bg: "#2f6fed", fg: "#ffffff" },
  purple: { bg: "#8e44ad", fg: "#ffffff" },
  pink: { bg: "#e84393", fg: "#ffffff" },
  brown: { bg: "#8d6e63", fg: "#ffffff" },
  transparent: { bg: "transparent", fg: "#ffffff" },
};
export function cardColors(color: string, mode: "background" | "strip") {
  const c =
    CARD_COLOR_CSS[color] ??
    (color.startsWith("#") ? { bg: color, fg: "#ffffff" } : CARD_COLOR_CSS.charcoal!);
  if (mode === "strip") return { bg: CARD_COLOR_CSS.charcoal!.bg, fg: "#ffffff", strip: c.bg };
  return { bg: c.bg, fg: c.fg, strip: null as string | null };
}
